// extracted by mini-css-extract-plugin
module.exports = {"contenedor_foto":"Eventos__contenedor_foto__OWahm","relativo":"Eventos__relativo__qIQ8P","message":"Eventos__message__1i6LX"};